import * as yup from "yup";
import { REGEX_PATTERNS } from "./constants";

/**
 * Schemas de validação reutilizáveis usando Yup
 */

export const validationSchemas = {
  email: yup
    .string()
    .email("Por favor insira um endereço de e-mail válido!")
    .required("Por favor insira um endereço de e-mail!"),

  phone: yup
    .string()
    .required("Por favor insira um número de telefone!")
    .matches(
      REGEX_PATTERNS.PHONE,
      "Por favor insira um número de telefone válido"
    ),

  zipCode: yup
    .string()
    .required("Por favor insira um CEP!")
    .matches(REGEX_PATTERNS.ZIP_CODE, "Insira um CEP válido!"),

  password: yup
    .string()
    .required("Insira uma senha!")
    .min(8, "Insira uma senha válida!"),

  requiredString: (fieldName = "Este campo") =>
    yup.string().required(`${fieldName} é obrigatório!`),
};

/**
 * Cria um schema de validação comum para formulários de contato
 */
export const createContactSchema = (fields = {}) => {
  return yup.object().shape({
    companyName: fields.companyName || validationSchemas.requiredString("Nome da empresa"),
    companyEmail: fields.companyEmail || validationSchemas.email,
    companyPhone: fields.companyPhone || validationSchemas.phone,
    message: fields.message || yup.string(),
    ...fields.custom,
  });
};

/**
 * Cria um schema de validação comum para checkout
 */
export const createCheckoutSchema = (fields = {}) => {
  return yup.object().shape({
    firstName: fields.firstName || validationSchemas.requiredString("Nome"),
    lastName: fields.lastName || validationSchemas.requiredString("Sobrenome"),
    email: fields.email || validationSchemas.email,
    phoneNumber: fields.phoneNumber || validationSchemas.phone,
    address: fields.address || validationSchemas.requiredString("Endereço"),
    zipCode: fields.zipCode || validationSchemas.zipCode,
    companyName: fields.companyName || yup.string(),
    companyAddress: fields.companyAddress || yup.string(),
    addressComplement: fields.addressComplement || yup.string(),
    city: fields.city || yup.string(),
    state: fields.state || yup.string(),
    ...fields.custom,
  });
};

